import { usePublicApi } from "api/setup";
import { ApiError } from "api/shared";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

interface GenerateExcelDownloadResponse {
  errorMessage: string;
  inProgress: boolean;
  lastGenerated: string;
  lastInvocationId?: string;
  queued: string;
  success: boolean;
}

export const useGenerateExcelDownloadMutation = ({
  companyId,
}: {
  companyId: string;
}) => {
  return usePublicApi<GenerateExcelDownloadResponse, ApiError>(
    {
      url: formatUrl(api.companies.excel.one, { companyId }),
      method: "POST",
    },
    { manual: true }
  );
};
